import type { BackendContextType } from '@contexts/useBackend/useBackend';

/** The one client-library call both OAuth entry points (Add channel, Reconnect) go through. */
export type SystemsIntegrationsWebhooksGet = Pick<BackendContextType['backend']['get'], 'systems_integrations_webhooks_get'>;

export type OAuthAuthorizationUrlRequest = {
  connectorId: string;
  /** Sent by Add channel for MercadoLibre. The server does not read it: the connector authorizes on MLA. */
  site?: string;
  /** Per-store providers (TiendaNube, Shopify, Fenicio) authorize on the seller's own domain. */
  storeUrl?: string;
  /**
   * TV1-2446 (design D5) — set only by Reconnect: the provider user id of the channel being
   * restored. The server refuses a Reconnect for a connector that does not enforce it.
   */
  expectedIntegrationUserId?: string;
};

/**
 * Asks the server for a connector's OAuth authorization URL
 * (`GET /systems-integrations/:connectorId/get-authorization-url`).
 */
export const requestOAuthAuthorizationUrl = async (
  webhooks: SystemsIntegrationsWebhooksGet,
  request: OAuthAuthorizationUrlRequest
): Promise<string | undefined> => {
  const params = { route: 'get-authorization-url', ...request };
  // The generated client type for this endpoint is stale — it declares only
  // `{ connectorId, route }` params and a `void` return, but the endpoint
  // reads `storeUrl` / `expectedIntegrationUserId` from the query and returns `{ url }`.
  // Assert the real response shape rather than falling back to `any`. This is the
  // single cast site for the call (moved here from `AddChannelModal`).
  const authResult = ( await webhooks.systems_integrations_webhooks_get( params )) as unknown as { url?: string };
  return authResult?.url;
};
